import React from "react";

import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { questions } from "@egovernments/digit-ui-module-obps/src/components/LandUseNOC/constant";

function ViewLandUseNoc({ itemData }) {
  const { t } = useTranslation();

  const nocEmployeeData = itemData?.nocDetails;
  const nocApplicantData = itemData?.nocDetailsApplicant;
  console.log("nocApplicantData", nocApplicantData);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  console.log("loggg.........", itemData, nocEmployeeData);
  const otherNocDetails = nocEmployeeData?.othersDetails;
  if (!nocApplicantData) return <p className="error">Please enter NOC details.</p>;
  return (
    <React.Fragment>
      <div style={{ margin: "10px 5%" }}>
        <Paper sx={{ overflow: "hidden", marginY: 2 }}>
          <div style={{ marginLeft: "8px", fontSize: "24px", padding: "8px", fontWeight: "500" }}>{`${t("BPA_MY_APPLICATIONS_LANDUSENOC")}`}</div>
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ border: "1px solid #436387" }}>Sr No</StyledTableCell>
                  <StyledTableCell sx={{ border: "1px solid #436387" }}>Name</StyledTableCell>
                  <StyledTableCell sx={{ border: "1px solid #436387" }}>Input</StyledTableCell>
                  <StyledTableCell sx={{ border: "1px solid #436387" }}>Officer Input</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {questions
                  .reduce((yesNoc, questionItem, index) => {
                    const { label, applicantName, employeeName } = questionItem;
                    console.log("informationApplicant", label, applicantName, employeeName);

                    // Check if the applicant's NOC is true
                    // if (nocApplicantData[applicantName] === true) {
                    console.log("insdieapplicantyes");

                    yesNoc.push({
                      id: yesNoc.length + 1,
                      question: label,
                      answer: nocApplicantData[applicantName] ? "Yes" : "No",
                      employee: nocEmployeeData[employeeName] ? "Yes" : "No", // Determine employee's value
                    });
                    // }
                    console.log("yesNOC", yesNoc);

                    return yesNoc;
                  }, [])
                  .map(({ id, question, answer, employee }) => (
                    <StyledTableRow key={id} sx={{ "&:last-child td, &:last-child th": { border: "1px solid #ddd" } }}>
                      <StyledTableCell>{id}</StyledTableCell>
                      {question === "Other NOC" ? (
                        <StyledTableCell>{`${question} : ${nocEmployeeData.othersDetails}`}</StyledTableCell>
                      ) : (
                        <StyledTableCell>{question}</StyledTableCell>
                      )}
                      <StyledTableCell>{answer}</StyledTableCell>
                      <StyledTableCell>{employee}</StyledTableCell> {/* New column for employee values */}
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </div>
    </React.Fragment>
  );
}

export default ViewLandUseNoc;
